import { useState } from 'react';
import ChatInterfacePanel from './blocks/ChatInterfacePanel';
import { ReferenceViewer } from './blocks/ReferenceViewer/ReferenceViewer';
import { scrollTo } from '../../../utils/document';
import useMessageHandler from '../../../hooks/useMessageHandler';
import { Header, Main } from '../../layout/styled';
import Button from '../../common/Button';
import { Flex } from './styled';
import logo from '../../../assets/verbum-logo.svg';

export default function IndexPage() {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { messages, resetThread, submitMessage } = useMessageHandler();

    function displayPdfPage(targetPageNum: number) {
        setIsOpen(true);
        setTimeout(() => {
            // To avoid issues with scrolling
            // 50–150ms is often enough
            scrollToPdfPage(targetPageNum);
        }, 100);
    }

    function scrollToPdfPage(pageNum: number) {
        scrollTo(`pdf-page-${pageNum}`);
    }

    function toggleViewer() {
        setIsOpen((prev) => !prev);
        setTimeout(() => {
            // To avoid issues with scrolling
            // 50–150ms is often enough
            scrollToPdfPage(1);
        }, 100);
    }

    function openInNewTab(url: string) {
        const opened = window.open(url, '_blank');
        if (!opened) return;
        opened.focus();
    }

    return (
        <>
            <Header>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <img
                        src={logo}
                        alt="Verbum - Kyrkoordningen"
                        style={{ height: '60px', objectFit: 'contain' }}
                    />
                    <span
                        style={{
                            color: '#333',
                            fontSize: '18px',
                            fontWeight: '530',
                        }}
                    >
                        Kyrkoordningen AI{' '}
                        <span
                            style={{
                                backgroundColor: '#e0e0e0', // light grey
                                color: '#333',
                                padding: '3px 6px',
                                borderRadius: '4px',
                                fontSize: '14px',
                                fontWeight: 'bold',
                            }}
                        >
                            BETA
                        </span>
                    </span>
                </div>

                <Flex>
                    <Button
                        text="Lämna feedback"
                        onClick={() => openInNewTab('https://tally.so/r/3yQMg0')}
                        color="primary"
                    />
                    <Button text="Rensa" onClick={resetThread} color="primary" />
                </Flex>
            </Header>
            <Main>
                <ChatInterfacePanel
                    messages={messages}
                    submitMessage={submitMessage}
                    displayPdfPage={displayPdfPage}
                />
                <ReferenceViewer
                    src="/data/kyrkoordningen_2026.pdf"
                    isOpen={isOpen}
                    toggle={toggleViewer}
                />
            </Main>
        </>
    );
}
